var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.388184H7.2C2.604 0.388184 0 2.99219 0 7.58818V20.1882C0 24.7842 2.604 27.3882 7.2 27.3882H19.8121C24.408 27.3882 27 24.7842 27 20.1882V7.58818C27 2.99219 24.408 0.388184 19.8121 0.388184Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21875 19.9271C9.21875 19.3365 9.69688 18.8584 10.2875 18.8584C10.8711 18.8584 11.3492 19.3365 11.3492 19.9271C11.3492 20.5107 10.8711 20.9889 10.2875 20.9889C9.69688 20.9889 9.21875 20.5107 9.21875 19.9271ZM17.1289 19.9271C17.1289 19.3365 17.607 18.8584 18.1977 18.8584C18.7813 18.8584 19.2594 19.3365 19.2594 19.9271C19.2594 20.5107 18.7813 20.9889 18.1977 20.9889C17.607 20.9889 17.1289 20.5107 17.1289 19.9271Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2591 9.91506C19.688 9.91506 19.9693 10.0627 20.2505 10.3862C20.5318 10.7096 20.581 11.1737 20.5177 11.5948L19.8497 16.2073C19.7232 17.094 18.9638 17.7472 18.0708 17.7472H10.3997C9.46458 17.7472 8.69115 17.03 8.6138 16.1026L7.96693 8.43779L6.90521 8.25498C6.62396 8.20576 6.42708 7.93154 6.4763 7.65029C6.52552 7.36201 6.79974 7.17217 7.08802 7.21435L8.76498 7.46748C9.00404 7.51037 9.17982 7.70654 9.20091 7.9456L9.33451 9.5206C9.3556 9.74631 9.53841 9.91506 9.76341 9.91506H19.2591ZM14.9982 13.5706H16.9458C17.2411 13.5706 17.4732 13.3315 17.4732 13.0433C17.4732 12.7479 17.2411 12.5159 16.9458 12.5159H14.9982C14.7029 12.5159 14.4708 12.7479 14.4708 13.0433C14.4708 13.3315 14.7029 13.5706 14.9982 13.5706Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.87cc3431c12f177370806fbcb8151e54.svg";
export { ForwardRef as ReactComponent };